import React from 'react';
import ImageGallery from 'react-image-gallery';
import './Slideshow.css';

import Image1 from '../images/home/01.jpg';
import Image2 from '../images/home/02.jpg';
import Image3 from '../images/home/03.png';
import Image4 from '../images/home/04.jpg';
import Image5 from '../images/home/05.png';
import Image6 from '../images/home/06.PNG';
import Image7 from '../images/home/07.PNG';
import Image8 from '../images/home/08.png';
import Image9 from '../images/home/09.jpg';
import Image10 from '../images/home/10.jpg';
import Image11 from '../images/home/11.jpg';
import Image12 from '../images/home/12.jpg';
import Image13 from '../images/home/13.PNG';
import Image14 from '../images/home/14.jpg';
import Image15 from '../images/home/15.png';
import Image16 from '../images/home/16.png';
import Image17 from '../images/home/17.png';
import Image18 from '../images/home/18.jpg';

const images = [
  { original: Image1 },
  { original: Image2 },
  { original: Image3 },
  { original: Image4 },
  { original: Image5 },
  { original: Image6 },
  { original: Image7 },
  { original: Image8 },
  { original: Image9 },
  { original: Image10 },
  { original: Image11 },
  { original: Image12 },
  { original: Image13 },
  { original: Image14 },
  { original: Image15 },
  { original: Image16 },
  { original: Image17 },
  { original: Image18 },
];

const falsy=false;

const Slideshow = () => {
    return (
      <div className='slideshow-div'>
        <ImageGallery items={images}
                      showThumbnails={falsy}
                      showNav={falsy}
                      autoPlay={!falsy}
                      showPlayButton={falsy}
                      showFullscreenButton={falsy}/>
      </div>
    )
};

export default Slideshow;
